enum workOrderTypes {
    VISIT = 'visit',
    LAB = 'lab',
}

export default workOrderTypes;
